import { useLoaderData, useSearchParams, type LoaderFunctionArgs } from 'react-router';
import { BackLink } from '@/components/back-link';
import { api } from '@/lib/api';
import { TemplateEditor, type TemplateData } from './template-editor';

export async function templateLoader({ params }: LoaderFunctionArgs) {
  const [template, versions] = await Promise.all([
    api<TemplateData>(`/templates/${params.id}`),
    api<Array<{ version: number; note: string; createdBy: string; createdAt: string; size: number }>>(`/templates/${params.id}/versions`),
  ]);
  return { template, versions };
}

export function TemplatePage() {
  const { template, versions } = useLoaderData<typeof templateLoader>();
  const [searchParams] = useSearchParams();
  const warnings = searchParams.get('warnings');
  return (
    <div className="space-y-4">
      <BackLink to="/templates">Templates</BackLink>
      {warnings && <p className="rounded-md border border-amber-300 bg-amber-50 p-2 text-xs text-amber-900">AI notes: {warnings}</p>}
      <TemplateEditor key={template.id} template={template} versions={versions} />
    </div>
  );
}
